// A field counts as handled when it's mapped to a HubSpot property or
// explicitly marked "none" (not used). Anything else is still open.
export const isFieldMapped = (mapping) =>
  mapping === "none" || !!mapping?.field;

export const getMappingProgress = (panoraFields, localMapping) => {
  const fields = Object.values(panoraFields ?? {}).flat();
  const mapped = fields.filter((field) =>
    isFieldMapped(localMapping?.[field.field_name]),
  ).length;
  return { mapped, total: fields.length };
};
